import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import notificationService from '../../../services/notificationService';
import { useEmployeeSelfService } from '../../../contexts/EmployeeSelfServiceContext';

const PreferencesSection = ({ onNotify }) => {
  const { employee, notificationPrefs, setNotificationPrefs } = useEmployeeSelfService();
  const [saving, setSaving] = useState(false);

  const toggle = (key) => setNotificationPrefs((p) => ({ ...p, [key]: !p[key] }));

  const handleSave = async () => {
    if (!employee?.id) return;
    setSaving(true);
    try {
      const result = await notificationService.updatePreferences(employee.id, {
        in_app: notificationPrefs.inApp,
        email: notificationPrefs.email,
        sms: notificationPrefs.sms,
        attendance_alerts: notificationPrefs.attendanceAlerts,
        payroll_alerts: notificationPrefs.payrollAlerts,
        leave_updates: notificationPrefs.leaveUpdates,
      });
      if (result.success) {
        onNotify?.({ message: 'Preferences saved', type: 'success' });
      } else {
        onNotify?.({ message: result.error || 'Save failed', type: 'error' });
      }
    } finally {
      setSaving(false);
    }
  };

  const rows = [
    { key: 'inApp', label: 'In-app notifications' },
    { key: 'email', label: 'Email notifications' },
    { key: 'sms', label: 'SMS notifications' },
    { key: 'attendanceAlerts', label: 'Attendance alerts' },
    { key: 'payrollAlerts', label: 'Payroll alerts' },
    { key: 'leaveUpdates', label: 'Leave status updates' },
  ];

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      <div>
        <h2 className="text-xl font-semibold">Notification Preferences</h2>
        <p className="text-sm text-muted-foreground">Choose how you want to be notified</p>
      </div>

      <div className="bg-card border rounded-lg divide-y max-w-lg">
        {rows.map((row) => (
          <label key={row.key} className="flex items-center justify-between p-4 cursor-pointer">
            <span className="text-sm">{row.label}</span>
            <input
              type="checkbox"
              checked={!!notificationPrefs[row.key]}
              onChange={() => toggle(row.key)}
              className="h-4 w-4"
            />
          </label>
        ))}
      </div>

      <Button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save Preferences'}</Button>
    </div>
  );
};

export default PreferencesSection;
